<template>
  <div id="manuals">
    <div class="title">
      <h2>{{ $t("volunteers.manuals") }}</h2>
    </div>
    <div class="row">
      <div
        v-for="manual in manualList"
        :key="manual.title"
        class="manual"
      >
        <h6 @click="openDocument(manual.file)">
          {{ manual.title }}
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
/* global moment */
import eventConfig from '@/data/events_data.js'

export default {
  name: 'Manuals',
  computed: {
    user () {
      return this.$store.getters['getUser']
    },
    event () {
      return this.$store.getters['events/getList'](
        this.$route.params.event_id
      )
    },
    currentConfig () {
      return eventConfig[this.selectedEventType] || { manuals: [] }
    },
    manualList () {
      return (this.currentConfig.manuals || []).map(manual => {
        if (!this.event) return
        const file =
          manual.urlTemplate
            .replace('{edition}', this.event.edition) +
          '?' +
          moment().valueOf()
        return {
          title: this.$t(manual.titleKey),
          file
        }
      })
    },
    selectedEventType () {
      if (this.user) {
        return this.user.events[this.$route.params.event_id].type
      } else return 0
    }
  },
  methods: {
    openDocument (file) {
      window.open(`${process.env.VUE_APP_APP_URL}${file}`)
    }
  }
}
</script>

<style lang="scss" scoped>
#manuals {
  .row {
    .manual {
      height: auto;
      @include background($image: img("pdf.svg"), $position: left, $size: 40px);
      cursor: pointer;
      width: fit-content;

      h6 {
        padding: 10px 0 10px 40px;
        text-decoration: underline;
      }
    }
  }
}
</style>
